module.exports = __webpack_public_path__ + "static/lake_aerial_7-112ef0d0b0f238b45e5cc457b1e58e75.jpg";